import { Route, Routes } from "react-router-dom"
import { Helmet } from "react-helmet-async"
import { HardRefresh } from "source/shared/routingUtils"
import { useSession } from "source/shared/hooks/useSession"
import MessageShow from "./MessageShow"
import FormWrapper from "./components/FormWrapper"
import FormSubmissionVerification from "./components/FormSubmissionVerification"
import HouseholdInviteAcceptance from "./components/HouseholdInviteAcceptance"
import DirectoryInvitationAccept from "./components/DirectoryInvitationAccept"
import DirectoryInvitationDecline from "./components/DirectoryInvitationDecline"

export function Messages() {
  useSession(true)

  return (
    <>
      <Routes>
        <Route path="/:id" element={<MessageShow />} />
      </Routes>
      <Helmet title="Messages" />
    </>
  )
}

export function People() {
  return (
    <Routes>
      <Route path="*" element={<HardRefresh />} />
      <Route path={"/forms/:id"} element={<FormWrapper />} />
      <Route
        path={"/forms/submissions/verify"}
        element={<FormSubmissionVerification />}
      />
      <Route
        path={"/forms/submissions/accept_household_invite"}
        element={<HouseholdInviteAcceptance />}
      />
      <Route
        path={"/directory_invitations/accept"}
        element={<DirectoryInvitationAccept />}
      />
      <Route
        path={"/directory_invitations/decline"}
        element={<DirectoryInvitationDecline />}
      />
    </Routes>
  )
}
